var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btnBlock"},[_c('a',{on:{"click":_vm.printme}},[_c('i',{staticClass:"fas fa-file-pdf"})])])}
var staticRenderFns = []

export { render, staticRenderFns }